export const DATA_ROOM_DRAG_TYPE = "data-room-item" as const;

export type DataRoomDragItemType = "file" | "folder";

export type DataRoomDragData = {
  [DATA_ROOM_DRAG_TYPE]: true;
  itemType: DataRoomDragItemType;
  itemId: string;
  itemName: string;
  fileIds: string[];
  folderIds: string[];
};

export type DataRoomDropTargetData = {
  type: "folder";
  folderId: string;
  folderName: string;
};

export function isDataRoomDragData(
  data: Record<string | symbol, unknown>,
): data is DataRoomDragData {
  return data[DATA_ROOM_DRAG_TYPE] === true;
}

export function isDataRoomDropTargetData(
  data: Record<string | symbol, unknown>,
): data is DataRoomDropTargetData {
  return data.type === "folder" && typeof data.folderId === "string";
}

export function resolveMoveSelection(args: {
  itemType: DataRoomDragItemType;
  itemId: string;
  selectedFiles: string[];
  selectedFolders: string[];
}): { fileIds: string[]; folderIds: string[] } {
  const { itemType, itemId, selectedFiles, selectedFolders } = args;

  const inFileSelection =
    itemType === "file" && selectedFiles.includes(itemId);
  const inFolderSelection =
    itemType === "folder" && selectedFolders.includes(itemId);

  if (inFileSelection) {
    if (selectedFiles.length > 1 || selectedFolders.length > 0) {
      return {
        fileIds: [...selectedFiles],
        folderIds: [...selectedFolders],
      };
    }
    return { fileIds: [itemId], folderIds: [] };
  }

  if (inFolderSelection) {
    if (selectedFolders.length > 1 || selectedFiles.length > 0) {
      return {
        fileIds: [...selectedFiles],
        folderIds: [...selectedFolders],
      };
    }
    return { fileIds: [], folderIds: [itemId] };
  }

  if (itemType === "file") {
    return { fileIds: [itemId], folderIds: [] };
  }

  return { fileIds: [], folderIds: [itemId] };
}
